import type {ReactElement} from 'react';
import React from 'react';
import {BaseGammaOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-gamma-option';
import type {GammaColorType} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-gamma-option/base-gamma-option.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromGammaOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromGammaOfActiveItem';

export function ItemGammaOption(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemGammaValue = useGetKeyFromGammaOfActiveItem('isEnabled');
  const activeItemGammaRed = useGetKeyFromGammaOfActiveItem('red');
  const activeItemGammaGreen = useGetKeyFromGammaOfActiveItem('green');
  const activeItemGammaBlue = useGetKeyFromGammaOfActiveItem('blue');

  if (
    !activeItem ||
    (activeItem && !('effects' in activeItem)) ||
    activeItemGammaValue === undefined ||
    activeItemGammaBlue === undefined ||
    activeItemGammaGreen === undefined ||
    activeItemGammaRed === undefined
  ) {
    throw new Error(`Item doesn't have effects property`);
  }

  const onToggleGamma = (): void => {
    void activeItem.updateFromObject({
      effects: {
        gamma: {
          isEnabled: !activeItemGammaValue,
        },
      },
    });
  };

  const onUpdateColor = (color: GammaColorType, updatedValue: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          gamma: activeItem.effects.getPartialUpdatedGammaObjectFromParams(updatedValue, color),
        },
      },
      {
        undoable,
      }
    );
  };

  return (
    <BaseGammaOption
      gamma={{
        green: activeItemGammaGreen,
        red: activeItemGammaRed,
        blue: activeItemGammaBlue,
        isEnabled: activeItemGammaValue,
      }}
      updateColor={onUpdateColor}
      onToggleGamma={onToggleGamma}
    />
  );
}
